export default __webpack_public_path__ + "static/media/quotes.1122d1fd.svg";